import { apm } from "@elastic/apm-rum";
import { IFullNode } from "@inovitas/infra3dsdk/dist/types/mm/api/interfaces/IFullNode";
import { Menu, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { topbarStore } from "shared/common/stores/topbarStore";
import MenuWithPointerForwarding from "shared/ui/muiComponentWrappers/MenuWithPointerForwarding";
import { campaignType } from "./Campaign";

interface Props {
  campaigns: campaignType[];
}
export default function CampaignSwitcher({ campaigns }: Props) {
  const viewer = defaultStore((state) => state.viewer);
  const activeCampaign = defaultStore((state) => state.activeCampaign);
  const changeActiveCampaign = defaultStore(
    (state) => state.changeActiveCampaign
  );
  const changeAlertMessage = defaultStore((state) => state.changeAlertMessage);

  const anchorDate = topbarStore((state) => state.anchorDate);
  const changeAnchorDate = topbarStore((state) => state.changeAnchorDate);

  const { t } = useTranslation();

  const DateId = "Date";
  const isDateOpen = Boolean(anchorDate);
  const suppressAlertRef = useRef(false); // What does this name mean? 13
  let prev_node: IFullNode;
  let current_node: IFullNode;

  //close change view date modal
  const handleDateClose = () => {
    changeAnchorDate(null);
  };

  //change campaing function
  const handleChangeCampaign = (campaign: campaignType) => {
    suppressAlertRef.current = true;
    viewer?.moveToCampaign(campaign.campaignID);
    changeActiveCampaign(campaign);
  };

  //whenever campaign is changed made an alert message that campaign is changed
  useEffect(() => {
    if (viewer == undefined) return;
    viewer.on("nodechanged", (node: IFullNode) => {
      prev_node = current_node;
      current_node = node;
      if (prev_node) {
        if (
          prev_node.frame.campaignID !== current_node.frame.campaignID &&
          prev_node.frame.collection == current_node.frame.collection &&
          !suppressAlertRef.current
        ) {
          changeAlertMessage({
            message: t("alert_info.campaign_changed"),
            type: "info",
          });
        }
      }
      suppressAlertRef.current = false;
    });
  }, [viewer]);

  return (
    <MenuWithPointerForwarding
      anchorEl={anchorDate}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id={DateId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isDateOpen}
      onClose={handleDateClose}
      sx={{
        padding: 0,
        marginTop: "6px",
      }}
      classes={{ list: "infra3d-listPopover" }}
    >
      {activeCampaign !== undefined &&
        campaigns.map((item: campaignType) => (
          <MenuItem
            key={item.campaignID}
            sx={{
              gap: "10px",
              backgroundColor: "darkblue.main",
              color:
                activeCampaign.campaignID === item.campaignID
                  ? "secondary.main"
                  : "white",
              "@media (hover: hover)": {
                ":hover": {
                  color: "secondary.main",
                  backgroundColor: "darkblue.main",
                },
              },
            }}
            onClick={() =>
              monitor(apm, "change-campaign | Campaigns", () => {
                handleChangeCampaign(item);
                handleDateClose();
              })
            }
          >
            <Typography variant="body1" fontSize={"13px"} fontWeight={500}>
              {item.description}
            </Typography>
          </MenuItem>
        ))}
    </MenuWithPointerForwarding>
  );
}
